import { render, staticRenderFns } from "./PanelComercios.vue?vue&type=template&id=2d59e945&scoped=true&"
import script from "./PanelComercios.vue?vue&type=script&lang=js&"
export * from "./PanelComercios.vue?vue&type=script&lang=js&"
import style0 from "./PanelComercios.vue?vue&type=style&index=0&id=2d59e945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d59e945",
  null
  
)

export default component.exports